import "../comp-styles/Loader.scss";

const LoaderCircle = ({Width, Height}) => {
    return(
        <div style={{width:Width, height:Width}} className="loader_circle"/>
    )
}

export default LoaderCircle;
